// Vuex transaction module actions
import { API } from '@/config';
import { FILL_LIST } from '../supervisors/mutations-types';

export default {
  async getUserFaq({ commit }) {
    try {
      const response = await API.get('/user/getFaq');
      commit(FILL_LIST, response.data.data);
    } catch (err) {
      console.log(err);
    }
  },

};
